import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Token para que una petición HTTP NO dispare el overlay global de carga.
 * Útil en peticiones frecuentes y rápidas (sort/search/paginación de tablas)
 * cuyo feedback de carga ya se muestra localmente.
 */
export const SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);

/**
 * Helper para construir el HttpContext con SKIP_GLOBAL_LOADING activado.
 * Uso: `this.http.get(url, { context: skipGlobalLoading() })`.
 */
export function skipGlobalLoading(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_GLOBAL_LOADING, true);
}
